import CenteredContent from 'components/CenteredContent/CenteredContent';
import Skeleton from 'components/Skeleton/Skeleton';
import useMobileView from 'hooks/useMobileView';
import CarouselSkeleton from './Carousel/Carousel.fallback';
import useStyles from './styles';

export const ExploreBannerDesktopSkeleton = () => {
  const styles = useStyles();
  return (
    <div className={styles.root} data-testid="exploreBanner-skeleton-root">
      <CenteredContent>
        <Skeleton className={styles.skeletonTitle} />
      </CenteredContent>
      <CarouselSkeleton />
    </div>
  );
};

export const ExploreBannerMobileSkeleton = () => {
  const styles = useStyles();
  return (
    <div className={styles.root} data-testid="exploreBanner-skeleton-root--mobile">
      <CenteredContent>
        <Skeleton className={styles.skeletonTitle} />
      </CenteredContent>
      <CarouselSkeleton />
    </div>
  );
};

const ExportBannerSkeleton = () => {
  const { isMobile } = useMobileView();

  if (isMobile) {
    return <ExploreBannerMobileSkeleton />;
  }

  return <ExploreBannerDesktopSkeleton />;
};

export default ExportBannerSkeleton;
